import {
  MediaSize,
  ReviewSubmissionConfig as IReviewSubmissionConfig
} from 'services/api-service'

export class ReviewSubmissionConfig implements IReviewSubmissionConfig {
  constructor(config: IReviewSubmissionConfig) {
    this.termsUrl = config.termsUrl
    this.acceptTermsRequired = config.acceptTermsRequired
    this.deviceFingerprintOn = config.deviceFingerprintOn
    this.mediaSizes = config.mediaSizes
    this.recommendRequired = config.recommendRequired
    this.showRangeMiddle = config.showRangeMiddle
    this.showRecommend = config.showRecommend
    this.showSweepstakes = config.showSweepstakes
    this.textMinLength = config.textMinLength
    this.textMaxLength = config.textMaxLength
    this.textRequired = config.textRequired
    this.titleMaxLength = config.titleMaxLength
    this.titleRequired = config.titleRequired
  }

  acceptTermsRequired: boolean
  termsUrl: string
  deviceFingerprintOn: boolean
  mediaSizes: Array<MediaSize>
  recommendRequired: boolean
  showRangeMiddle: boolean
  showRecommend: boolean
  showSweepstakes: boolean
  textMinLength: number
  textMaxLength: number
  textRequired: boolean
  titleMaxLength: number
  titleRequired: boolean
}

let defaultConfig: IReviewSubmissionConfig = {}
export function loadConfig(config: IReviewSubmissionConfig) {
  defaultConfig = new ReviewSubmissionConfig(config)
}
export { defaultConfig as default }
